import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

import './mixins/global';
import * as components from './components';
import plugins from './plugins';
import store from './store';

import UiIcon from './components/ui/icon.vue';

plugins.init();

// Register global components
Vue.component('UiIcon', UiIcon);

new Vue({ // eslint-disable-line no-new
    components: {
        ...components,
    },
    el: '#app',
    mounted() {
        this.watchFormInputs();
    },
    computed: {
        ...mapState('modal', [
            'modal',
        ]),
    },
    methods: {
        ...mapMutations('modal', [
            'setModal',
        ]),

        watchFormInputs() {
            // Watch inputs
            const inputs = document.querySelectorAll('input, textarea');

            inputs.forEach((input) => {
                input.addEventListener('input', (e) => {
                    const inputGroup = e.target.closest('.form-group');

                    if (e.target.value) {
                        inputGroup.classList.add('active');
                    } else {
                        inputGroup.classList.remove('active');
                    }
                });
            });

            // Watch input files
            const inputFiles = document.querySelectorAll('input[type="file"]');

            inputFiles.forEach((input) => {
                input.addEventListener('change', (e) => {
                    const inputLabel = e.target.closest('label');
                    const inputFileName = inputLabel.querySelector('.input-file-name');
                    const fileName = e.target.files[0].name;

                    // If filename exists change file name else add it
                    if (inputFileName) {
                        inputFileName.innerText = fileName;
                    } else {
                        inputLabel.insertAdjacentHTML(
                            'beforeend',
                            `
                                <span class="input-file-name">
                                    ${fileName}
                                </span>
                            `,
                        );
                    }

                    e.target.closest('.form-file').classList.add('has-file');
                });
            });
        },

        closeMenu() {
            window.dispatchEvent(new Event('resize'));
        },
    },
    store,
});
